import {
  Box, Grid, ToggleButton, ToggleButtonGroup,
} from '@mui/material';

interface ToggleFixedAspectProps {
  value: boolean;
  handleChange: (value: boolean) => void;
}

const ToggleFixedAspect = ({ value, handleChange }: ToggleFixedAspectProps) => (
  <Grid item sx={{ width: '100%' }}>
    表示範囲
    <Box sx={{ py: 1 }}>
      <ToggleButtonGroup
        color="primary"
        value={value}
        exclusive
        onChange={(event, value) => handleChange(value)}
        aria-label="Platform"
      >
        <ToggleButton value>比率を固定する</ToggleButton>
        <ToggleButton value={false}>画像に合わせる</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  </Grid>
);

export default ToggleFixedAspect;
